export default {
"type": "FeatureCollection",
"name": "ZonaAcampada",
"crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
"features": [
{ "type": "Feature", "properties": { "Nom": "Camping Montserrat", "Observ": "Obert de de Setmana Sant a Tots Sants | e-correu: informacio@larsa-montserrat.com" }, "geometry": { "type": "Point", "coordinates": [ 1.838167816244896, 41.590776454286519 ] } }
]
}
